import React from "react";
import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, children, breadcrumb }) {
  return (
    <div className="mb-6">
      {breadcrumb && <div className="mb-2 text-xs text-ink-muted">{breadcrumb}</div>}
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink leading-none">
            {title}
          </h1>
          {subtitle && <p className="mt-1.5 text-sm text-ink-2">{subtitle}</p>}
        </div>
        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
    </div>
  );
}

export function SectionTitle({ children, className, action }) {
  return (
    <div className={cn("mb-3 flex items-center justify-between", className)}>
      <h3 className="font-display text-xl font-semibold text-ink">{children}</h3>
      {action}
    </div>
  );
}
